module.exports = __webpack_public_path__ + "img/konngjian.719fdc1a.webp";